import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import {decode} from 'html-entities';
import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import moment from "moment";
import { $ } from "react-jquery-plugin";
import { message } from "antd";
import { api, rules } from "../../apis/urls";


const RulesView = () => {

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        EventViews();
    },[]
    );


    const { id } = useParams();
    const[ result,setResult ] = useState('');
    const[ sessions,setSessions ] = useState('');
    const[ description,setDescription ] = useState('');
    const[ count,setCount ] = useState('');


    let navigate = useNavigate();


    const EventViews = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: api+'rules/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            //console.log(res.data.data)
            setCount(res.data.count)
            setResult(res.data.data);
            setSessions(res.data.data.sessions)
            setDescription(ReactHtmlParser(desc))

          });

    }


    const DeleteEvent = () => {

        let r = window.confirm("Are you sure you want to delete this Event?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: rules+"/"+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{

                console.log("response", response.data.message)

                if(response.data.message === "failed"){
                    message.warning("Please delete session")
                }else{
                    navigate("/rules")
                }
                            
            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
    }






    let onPublish = (rid,name) => {

        

        let token = "Bearer "+localStorage.getItem('token');

        const datas = {
            publish_status:"PUBLISHED"
        }
        
        const instance = axios.create({
            baseURL: rules+'/publish/'+rid,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.patch('',datas).then((response) =>{    
            message.success('rule published successfully')
            EventViews();
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
 }

 let onPending = (rid) => {



        let token = "Bearer "+localStorage.getItem('token');

        const datas = {
            publish_status:"PENDING"
        }
        
        const instance = axios.create({
            baseURL: rules+'/publish/'+rid,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.patch('',datas).then((response) =>{
            EventViews();
            
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
 }


    const desc = decode(result.instructions);
    const decrypted_desc = ReactHtmlParser(desc)

    return(
       
        <div>
        <aside class="right-side areas">    
            <div class="content-area dash-contentss">







            <div className="page-title-wrpr">
                    <div className="page-title-left-column">
                        
                        <h2 className="page-title">Rule - {decode(result.rule_name)}</h2>
                    </div>
                    <div className="page-rightside-action-column">
                        
                        
                    </div>
                
                
                </div>


                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to={"/rules"}>Test List</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Test View {decode(result.title)}</li>                    
                    </ol>
                </nav>





            <div class="event-details-wrprs" style={{margin:"auto", maxWidth:'100%'}}>


            <div class="row">
        <div class="col-md-12">
          <div class="row event-basic-details-wrpr">
            <div class="col-md-6">
                {result.image?
                    <img src={result.image} width="" height="100%" alt="" />:
                    <div className="img-wrpr" />
                }


            </div>
            <div class="col-md-6 event-basic-details">
              <h2>{decode(result.rule_name)}</h2>
                {decrypted_desc}



              <hr style={{marginBottom:0}} />


              <div class="fees-wrpr">
                    { /*
                    <div class="member-fee">
                        <label>Charge</label>
                        <div class="fee-content" style={{fontSize:'14px'}}>
                            ${result.amount}
                        </div>
                    </div> */ }
                    <div class="member-fee">
                        <label>Percentage of pass</label>
                        <div class="fee-content" style={{fontSize:'14px', maxWidth:'300px'}}>
                            {result.min_mark}%
                        </div>
                    </div>
                    <div class="member-fee">
                        <label>Last date</label>
                        <div class="fee-content" style={{fontSize:'14px'}}>
                            {moment(result.test_lastDate).format('ddd, MMM DD, YYYY')}
                        </div>
                    </div>
                </div>

                <hr style={{marginBottom:0}} />


                <div class="fees-wrpr">
                    <div class="member-fee">
                        <label>Status</label>
                        <div class="fee-content" style={{fontSize:'14px', color:result.publish_status === 'PUBLISHED'?'green':'red'}}>
                            {result.publish_status === "PUBLISHED"?"PUBLISHED":"UNPUBLISHED"}
                        </div>
                    </div>
                </div>

                <hr style={{marginBottom:0}} />
{count.count}

                <div className="list-action-wrpr showicons roundicons-text" style={{marginTop:'4%'}}>
                    <div className="list-action-wrpr">

                    <Link to={"/edit_rules/"+result.id} data-toggle="tooltip" title="Edit"><i  class="edit icon-pencil3"></i><span>Update</span></Link>
                    <button onClick={DeleteEvent} style={{background:"transparent"}} data-toggle="tooltip" title="Delete"><a><i class="delete icon-close1"></i><span>Delete</span></a></button>
                    {result.publish_status ==='PUBLISHED'?                                    
                        <button onClick={()=>{onPending(result.id)}} style={{background:"transparent"}} data-toggle="tooltip" title="Unpublish"><a><i class="delete icon-publish" style={{background:'#00eaad'}}></i><span>Unpublish</span></a></button>:
                        <button onClick={(e)=>{count ===0 ?alert('Atleast one question add and after pusblish'):onPublish(result.id)}} style={{background:"transparent"}} data-toggle="tooltip" title="Publish"><a><i class="delete icon-tick" style={{background:'#0069FF'}}></i><span>&nbsp;&nbsp;&nbsp;&nbsp;Publish&nbsp;&nbsp;&nbsp;&nbsp;</span></a></button>
                    }
                    </div>
                </div>

              




            </div>  
          </div>
        </div>
      </div>



                </div>
            </div>
        </aside>

    </div>








    )
}

export default RulesView;